module.exports = __webpack_public_path__ + "static/media/background-our-works-web.82badbc3.jpg";